import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useMembers = () => {
  const fetchContext = useContext(FetchContext);

  return useQuery(["members"], async () => {
    const { data } = await fetchContext.authAxios.get(`/members`);
    return data;
  });
};
